export default __webpack_public_path__ + "media/pro/title-154b63e4.svg";